import axios from 'axios'
import { BASE_API_URL } from '../configs/api'

export const getVideos = async () => {
    const resp = await axios.get(`${BASE_API_URL}/admin/get-videos`)
    return resp.data
}

export const createVideoWithData = async (data) => {
    const resp = await axios.post(`${BASE_API_URL}/admin/create-video`, data)
    return resp.data
}

export const deleteVideoId = async (data) => {
    const resp = await axios.post(`${BASE_API_URL}/admin/delete-video`, data)
    return resp.data
}
